// WorkspaceSwitcherV2 (Connect) — bản ĐẤU NỐI cho cụm dùng chung
// @cnv/ui/layout/WorkspaceSwitcherV2.
//
// Toàn bộ giao diện + luồng đổi workspace nằm ở kernel (hai hệ SaaS chung một bản, xem chú
// thích đầy đủ trong tệp đó). Ở đây chỉ còn những mảnh THẬT SỰ riêng của Connect:
//
//   • kho phiên: authApi + useAuthStore của host này
//   • MÔ HÌNH GÓI: Connect còn ở đời trước — bậc gói là CHUỖI ('none'|'free'|'pro') và
//     KHÔNG có bảng tên sản phẩm (`meta.plans` còn trống, xem PlanBadgeV2). Vì vậy tên gói
//     lấy thẳng `plan_label` của BE và bọc câu `Gói ...`. Khi Connect có danh mục gói thật
//     thì thêm bảng tên Ở ĐÂY, đừng chép bảng của Work — dán tên sản phẩm CNV Work lên
//     header Connect là lỗi người dùng đọc thấy ngay.
//
// Viên nhãn gói trên nút đọc từ query `['seat-status']` — ĐÚNG khoá mà PlanBadgeV2 (cùng
// thanh) và BillingPage dùng ⇒ về từ cache, KHÔNG phát sinh request thứ hai.

import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useLingui } from '@lingui/react/macro';
import WorkspaceSwitcher from '@cnv/ui/layout/WorkspaceSwitcherV2';
import { authApi, planApi } from '../../lib/inboxClient';
import { useAuthStore } from '../../lib/authStore';

export default function WorkspaceSwitcherV2() {
  const { t } = useLingui();
  const navigate = useNavigate();
  const activeTenant = useAuthStore((s) => s.activeTenant);
  const setActiveTenant = useAuthStore((s) => s.setActiveTenant);

  const { data: seat } = useQuery({
    queryKey: ['seat-status'],
    queryFn: () => planApi.seatStatus(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return (
    <WorkspaceSwitcher
      activeTenant={activeTenant}
      currentPlan={seat?.plan_label
        ? { label: t`Gói ${seat.plan_label}`, tier: seat.plan_tier || 'none' }
        : null}
      listTenants={() => authApi.listMyTenants()}
      switchTenant={(id) => authApi.switchTenant(id)}
      applySession={(res) => {
        setActiveTenant(res.active_tenant, res.accessToken, res.refreshToken);
        // ADR-030: switchTenant trả `user` với display_name + avatar CỦA WORKSPACE MỚI.
        if (res.user) {
          const cur = useAuthStore.getState().user || {};
          useAuthStore.setState({ user: { ...cur, ...res.user } });
        }
      }}
      planLabelOf={(row) => (row.plan_label ? t`Gói ${row.plan_label}` : null)}
      onSeeAll={() => navigate('/select-workspace')}
    />
  );
}
